export type {
  ColorAreaOnColorChangeData,
  ColorAreaProps,
  ColorAreaSlots,
  ColorAreaState,
} from './components/ColorArea/index';
export {
  ColorArea,
  colorAreaCSSVars,
  colorAreaClassNames,
  renderColorArea_unstable,
  useColorAreaStyles_unstable,
  useColorArea_unstable,
} from './components/ColorArea/index';
